import * as Sentry from '@sentry/react';

// QRスキャナー等の既知の無害なエラーは無視
const IGNORED_ERRORS = [
  'Cannot stop, scanner is not running',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
];

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE, // "production" | "development"
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // パフォーマンストレース: 本番10%サンプリング（無料枠節約）
    tracesSampleRate: 0.1,
    // セッションリプレイ: エラー時のみキャプチャ（無料枠節約）
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: IGNORED_ERRORS,
  });
}

export { Sentry };
